import React from 'react';
import ClientsContainer from "../containers/ClientsContainer";

const ClientsView = () => {

  return (
    <ClientsContainer/>
  );
};

export default ClientsView;
